module.exports = __webpack_public_path__ + "static/media/Christine Young Head Shot.c57d4a31.jpeg";